import { FC } from "react";
import * as React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface SectionVideoProps {
  description: string;
  video: string;
}

const SectionVideo: FC<SectionVideoProps> = ({ description, video }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: 5,
        alignItems: "center",
      }}
    >
      <Box width="100%">
        <Typography paragraph>{description}</Typography>
        <Box
          component="video"
          autoPlay
          muted
          playsInline
          loop
          sx={{ height: "100%", width: "100%", objectFit: "cover" }}
        >
          <Box component="source" src={video} type="video/mp4" />
        </Box>
      </Box>
    </Box>
  );
};

export default SectionVideo;
